var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatsSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "21.207pt",
    height: "18pt",
    viewBox: "900.225 -684.367 21.207 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Imported Layer 1",
    transform: "scale(1 -1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "scale(1 -1)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1 2",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 900.225,667.273 L 921.432,667.273 L 921.432,666.367 L 900.225,666.367 L 900.225,667.273 L 900.225,667.273 M 903.078,680.746 L 906.266,680.746 L 906.719,680.746 L 906.719,680.293 L 906.719,670.079 L 906.719,669.625 L 906.266,669.625 L 903.078,669.625 L 902.624,669.625 L 902.624,670.079 L 902.624,680.293 L 902.624,680.746 L 903.078,680.746 L 903.078,680.746 M 905.813,679.84 L 903.53,679.84 L 903.53,670.531 L 905.813,670.531 L 905.813,679.84 L 905.813,679.84 M 909.234,682.557 L 912.423,682.557 L 912.875,682.557 L 912.875,682.105 L 912.875,670.079 L 912.875,669.625 L 912.423,669.625 L 909.234,669.625 L 908.782,669.625 L 908.782,670.079 L 908.782,682.105 L 908.782,682.557 L 909.234,682.557 L 909.234,682.557 M 911.97,681.651 L 909.687,681.651 L 909.687,670.531 L 911.97,670.531 L 911.97,681.651 L 911.97,681.651 M 915.39,684.367 L 918.579,684.367 L 919.033,684.367 L 919.033,683.916 L 919.033,670.079 L 919.033,669.625 L 918.579,669.625 L 915.39,669.625 L 914.938,669.625 L 914.938,670.079 L 914.938,683.916 L 914.938,684.367 L 915.39,684.367 L 915.39,684.367 M 918.127,683.462 L 915.844,683.462 L 915.844,670.531 L 918.127,670.531 L 918.127,683.462 Z",
    stroke: "none",
    fill: "#323232",
    strokeWidth: 0.32,
    strokeLinejoin: "miter",
    markerStart: "none",
    markerEnd: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsSmallIcon);
export default __webpack_public_path__ + "static/media/stats-small-icon.1308738e7039ca8e17cb8301c4d46057.svg";
export { ForwardRef as ReactComponent };